import React, { useMemo } from "react";
import {
  Typography,
  Box,
  Chip,
  LinearProgress,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import CampaignIcon from "@mui/icons-material/Campaign";

export default function MarketingPage() {
  const kpis = useMemo(
    () => ({
      ctr: 3.8,
      conversion: 2.1,
      spend: 1240,
      roas: 3.2,
    }),
    []
  );

  const campaigns = useMemo(
    () => [
      {
        name: "Fall Launch",
        status: "Active",
        ctr: 4.2,
        spend: 530,
        conv: 2.4,
      },
      { name: "UGC Push", status: "Paused", ctr: 3.1, spend: 310, conv: 1.7 },
      {
        name: "Brand Awareness",
        status: "Active",
        ctr: 2.9,
        spend: 400,
        conv: 1.2,
      },
    ],
    []
  );

  const statusChip = (status) => (
    <Chip
      label={status}
      color={status === "Active" ? "success" : "default"}
      size="small"
      variant="outlined"
    />
  );

  return (
    <Box>
      {/* Header */}
      <div className="flex items-center gap-2 mb-2">
        <CampaignIcon className="text-primary-600 dark:text-primary-400" />
        <Typography variant="h6" className="text-2xl font-bold text-gray-900 dark:text-white">
          Marketing
        </Typography>
      </div>

      {/* KPI widgets */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mt-6">
        <div className="card-modern p-6">
          <Typography variant="subtitle2" className="text-sm text-gray-600 dark:text-gray-400 mb-2">
            CTR
          </Typography>
          <Typography variant="h5" className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
            {kpis.ctr}%
          </Typography>
          <LinearProgress
            variant="determinate"
            value={kpis.ctr}
            className="mt-2"
          />
        </div>
        <div className="card-modern p-6">
          <Typography variant="subtitle2" className="text-sm text-gray-600 dark:text-gray-400 mb-2">
            Conversion Rate
          </Typography>
          <Typography variant="h5" className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
            {kpis.conversion}%
          </Typography>
          <LinearProgress
            variant="determinate"
            value={kpis.conversion}
            className="mt-2"
          />
        </div>
        <div className="card-modern p-6">
          <Typography variant="subtitle2" className="text-sm text-gray-600 dark:text-gray-400 mb-2">
            Spend
          </Typography>
          <Typography variant="h5" className="text-2xl font-bold text-gray-900 dark:text-white">
            ${kpis.spend.toFixed(0)}
          </Typography>
        </div>
        <div className="card-modern p-6">
          <Typography variant="subtitle2" className="text-sm text-gray-600 dark:text-gray-400 mb-2">
            ROAS
          </Typography>
          <Typography variant="h5" className="text-2xl font-bold text-gray-900 dark:text-white">
            {kpis.roas}x
          </Typography>
        </div>
      </div>

      {/* Campaign table */}
      <div className="card-modern p-4 mt-6">
        <Typography variant="subtitle1" className="text-lg font-bold text-gray-900 dark:text-white mb-4">
          Campaigns
        </Typography>
        <Table size="small" sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell className="text-gray-700 dark:text-gray-300 font-semibold">Name</TableCell>
              <TableCell className="text-gray-700 dark:text-gray-300 font-semibold">Status</TableCell>
              <TableCell align="right" className="text-gray-700 dark:text-gray-300 font-semibold">CTR</TableCell>
              <TableCell align="right" className="text-gray-700 dark:text-gray-300 font-semibold">Spend</TableCell>
              <TableCell align="right" className="text-gray-700 dark:text-gray-300 font-semibold">Conversion</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {campaigns.map((c) => (
              <TableRow key={c.name} hover>
                <TableCell className="text-gray-900 dark:text-white">{c.name}</TableCell>
                <TableCell>{statusChip(c.status)}</TableCell>
                <TableCell align="right" className="text-gray-700 dark:text-gray-300">{c.ctr}%</TableCell>
                <TableCell align="right" className="text-gray-700 dark:text-gray-300">${c.spend.toFixed(0)}</TableCell>
                <TableCell align="right" className="text-gray-700 dark:text-gray-300">{c.conv}%</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </Box>
  );
}
